<template>
    <div>
        <sau-template :retrieved="gotData">
            <template slot="message">Fetching Event Log</template>

            <!-- Data -->
            <template slot="data">
                <template>
                    <h3>Event Log</h3>
                    <div v-if="Object.keys(transactions).length > 0" class="sau-bx bx-pad clearfix">
                        <table
                            id="data-table-transactions"
                            class="table table-hover data-table"
                            data-search="Search Events.."
                            data-sort="[0, 'desc']"
                            cellspacing="0"
                            width="100%"
                        >
                            <thead>
                                <tr>
                                    <th>Created At</th>
                                    <th>Action</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(transaction, index) in transactions" :key="index">
                                    <td>{{ transaction.created_at | moment('DD/MM/YYYY h:mm A') }}</td>
                                    <td>{{ formatAction(transaction.action) }}</td>
                                    <td>{{ transaction.status }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <sau-apiro-response type="message" support="true">
                            <template
                                slot="message"
                            >We're unable to retrieve any events for your VPS right now.</template>
                            <template slot="details">
                                <p>This is a temporary issue, so please try again later or contact our Support Team.</p>
                            </template>
                        </sau-apiro-response>
                    </div>
                </template>
            </template>
        </sau-template>
    </div>
</template>
<script>
import jsFunctions from '@js/store/jqueryFunctions';
export default {
    mixins: [jsFunctions],
    data() {
        return {
            transactions: {}
        };
    },
    created() {
        this.startApp();
    },
    methods: {
        startApp() {
            this.getVpsTransactions()
                .then(response => {
                    if (response.data) {
                        this.transactions = response.data;
                        this.$nextTick(() => {
                            this.initializeDataTables();
                        });
                    }
                })
                .catch(error => {});
        },
        formatAction(action) {
            /**
             * comes in format:
             * startup_virtual_machine
             * stop_virtual_machine
             * reboot_virtual_machine
             */
            return action.replace('_virtual_machines', '');
        }
    },
    computed: {}
};
</script>
